/** @file transportHandlers: what each transport binding does (the timeline's handlers). */
import { timelineHandlers } from '../panels/timeline/timelineHandlers';
import type { EditorStore } from '../state/editorTypes';

/** Play / pause, frame steps and keying, over the timeline's own handlers (no clipboard: these never copy or paste). */
export function transportHandlers(store: EditorStore): Record<string, () => void> {
  const h = timelineHandlers(store, { current: null });
  const run = (id: string) => (): void => { h[id]?.(); };
  return {
    'transport.play': run('timeline.playPause'),
    'transport.prevFrame': run('timeline.prevFrame'),
    'transport.nextFrame': run('timeline.nextFrame'),
    'transport.keyJoint': run('timeline.keyPose'),
    'transport.keyAll': run('timeline.keyAll'),
  };
}
